"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyToClipboard = exports.accessibility = exports.global = void 0;
const global = () => {
    /**
     * Global settings
     */
    // Preload and No-JS
    setTimeout(function () {
        document.documentElement.classList.remove('preload');
        document.documentElement.classList.remove('no-js');
    }, 300);
};
exports.global = global;
const accessibility = () => {
    /**
     * Toggle focus on when users are tabbing, and turn them off once
     * they begin clicking again
     */
    const handleFirstTab = (e) => {
        if (e.keyCode === 9) {
            document.body.classList.add('has-tabbing-user');
            window.removeEventListener('keydown', handleFirstTab);
            window.addEventListener('mousedown', handleMouseDownOnce);
        }
    };
    const handleMouseDownOnce = () => {
        document.body.classList.remove('has-tabbing-user');
        window.removeEventListener('mousedown', handleMouseDownOnce);
        window.addEventListener('keydown', handleFirstTab);
    };
    window.addEventListener('keydown', handleFirstTab);
};
exports.accessibility = accessibility;
const copyToClipboard = () => {
    document.addEventListener('click', function (event) {
        const target = event.target;
        if (!target.matches('[data-action="copy"]'))
            return;
        event.preventDefault();
        navigator.clipboard.writeText(target.getAttribute('href')).then(() => {
            alert('Copied link');
        }, () => {
            alert('Copying failed. Please try again');
        });
    }, false);
};
exports.copyToClipboard = copyToClipboard;
